import { useAtom } from 'jotai';

import {
  discoveryCallDevForceShowAtom,
  isDiscoveryCallDevOverridesEnabled,
} from '@/atoms/discoveryCallDevAtoms';
import { Switch } from '@heidi/design-system/switch';
import {
  TypographyCaption,
  TypographyP2SemiBold,
  typographyVariant,
} from '@heidi/design-system/typography';

/**
 * Force-shows the market-gated "Book a discovery call" sidebar footer CTA so it
 * can be QA'd without a hardcode. Deliberately narrow — see the in-panel copy.
 */
export function DiscoveryCallDevSection() {
  const [forceShow, setForceShow] = useAtom(discoveryCallDevForceShowAtom);

  if (!isDiscoveryCallDevOverridesEnabled()) {
    return null;
  }

  return (
    <section
      aria-labelledby="dev-tools-discovery-call-heading"
      className="mt-6 border-t border-border pt-6"
    >
      <TypographyP2SemiBold id="dev-tools-discovery-call-heading" className="mb-2">
        Book a discovery call CTA
      </TypographyP2SemiBold>
      <TypographyCaption className="mb-3 text-text-tertiary">
        Force-shows{' '}
        <span className={typographyVariant({ variant: 'captionBold' })}>
          only the sidebar footer “Book a discovery call” button
        </span>{' '}
        with a placeholder link, bypassing the market gate. Nothing else is affected.
        Clears when this tab closes.
      </TypographyCaption>

      <div className="flex items-center justify-between gap-3">
        <TypographyCaption className="text-text-secondary">
          Force footer CTA to show
        </TypographyCaption>
        <Switch
          checked={forceShow}
          onCheckedChange={setForceShow}
          data-testid="dev-tools-discovery-call-force-show"
          aria-label="Force the footer Book a discovery call CTA to show"
        />
      </div>
    </section>
  );
}
